import { createSlice } from "@reduxjs/toolkit";

const gisSlice = createSlice({
  name: "gisStore",
  initialState: {
    gisData: {}, // Initialize gisData as an empty object
    cropType: "", // Initialize cropType as an empty string
  },
  reducers: {
    updateGisStore(state, action) {
      const { gisData, cropType } = action.payload;
      state.gisData = gisData;
      state.cropType = cropType;
    },
  },
});

export const { updateGisStore } = gisSlice.actions;
export default gisSlice.reducer;